import { queryOptions, skipToken } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import {
  getComment,
  getComments,
} from 'networking/mindfeed/services/comment.service';
import type { CommentId, CommentSubject } from 'models/Comment';

// Comments change rarely and the user sees their own edits straight away
// through the mutations, so a long freshness window is fine.
const COMMENT_STALE_MS = 1000 * 60 * 5;

// The comments on a memo or a media item. A subject with no id (nothing to
// comment on yet): defined, never runs.
export const commentsQuery = (subject?: CommentSubject) =>
  queryOptions({
    queryKey: [QueryKey.COMMENTS, subject?.type, subject?.id],
    queryFn: subject?.id ? () => getComments(subject) : skipToken,
    staleTime: COMMENT_STALE_MS,
    refetchOnWindowFocus: false,
  });

// One comment by id, e.g. the parent of a reply. No id: defined, never runs.
export const commentQuery = (commentId?: CommentId) =>
  queryOptions({
    queryKey: [QueryKey.COMMENTS, 'comment', commentId],
    queryFn: commentId ? () => getComment(commentId) : skipToken,
    staleTime: COMMENT_STALE_MS,
    refetchOnWindowFocus: false,
  });
